import api from "services/api";
import { handlerEffects, handlerWrapper } from "../utils";
import initialState from "../utils/initialState";
import { constants, createModule } from "./redux-acron";

export default createModule({
  name: "reports",
  modelName: "reports",

  state: initialState.reports,

  // ------

  handlers: {
    downloadReport: (state, { payload, status = constants.PENDING_STATUS }) => {
      return handlerWrapper("currentReport", state, status, payload);
    }
  },

  effects: {
    downloadReport: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.reports.downloadReport,
          payload,
          actions.downloadReport
        );
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/ReportsModule.js